var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.componentType
        ? _c(_vm.componentType, {
            ref: "instance",
            tag: "components",
            attrs: {
              type: _vm.verifyType,
              figure: _vm.figure,
              arith: _vm.arith,
              width: _vm.width,
              height: _vm.height,
              fontSize: _vm.fontSize,
              codeLength: _vm.codeLength,
              mode: _vm.mode,
              vOffset: _vm.vOffset,
              vSpace: _vm.vSpace,
              explain: _vm.explain,
              imgUrl: _vm.imgUrl,
              imgName: _vm.imgName,
              imgSize: _vm.imgSize,
              blockSize: _vm.blockSize,
              barSize: _vm.barSize,
              defaultNum: _vm.defaultNum,
              checkNum: _vm.checkNum
            }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: { width: "0", height: "0" },
          on: { click: _vm.checkCode }
        },
        [
          _vm._t("check", [
            _c("button", { staticClass: "verify-btn" }, [
              _vm._v(_vm._s(_vm.i18n("ok")))
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1871d142", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1871d142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/verify/src/main.vue
// module id = iZO2
// module chunks = 28